import React, { useState } from "react";
import Icon from "components/AppIcon";

const DownloadHistory = ({ history }) => {
  const [page, setPage] = useState(1);
  const perPage = 5;
  const totalPages = Math.ceil(history?.length / perPage);
  const paginated = history?.slice((page - 1) * perPage, page * perPage);

  return (
    <div className="rounded-xl border bg-white" style={{ borderColor: "var(--color-border)", boxShadow: "var(--shadow-sm)" }}>
      <div className="p-4 md:p-5 border-b flex items-center gap-2" style={{ borderColor: "var(--color-border)" }}>
        <Icon name="History" size={18} color="var(--color-primary)" />
        <h2 className="font-semibold text-sm md:text-base" style={{ fontFamily: "var(--font-heading)", color: "var(--color-foreground)" }}>
          Historial de Descargas
        </h2>
        <span className="ml-auto text-xs px-2 py-0.5 rounded-full" style={{ backgroundColor: "var(--color-muted)", color: "var(--color-muted-foreground)" }}>
          {history?.length} registros
        </span>
      </div>
      {/* Desktop table */}
      <div className="hidden md:block overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr style={{ backgroundColor: "var(--color-muted)" }}>
              {["Actualización", "Versión", "Fecha y hora", "Estado"]?.map((h) => (
                <th key={h} className="text-left px-4 py-3 text-xs font-semibold uppercase tracking-wide" style={{ color: "var(--color-muted-foreground)", fontFamily: "var(--font-caption)" }}>
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y" style={{ borderColor: "var(--color-border)" }}>
            {paginated?.map((item) => (
              <tr key={item?.id} className="hover:bg-gray-50 transition-colors">
                <td className="px-4 py-3 font-medium text-sm" style={{ color: "var(--color-foreground)" }}>{item?.name}</td>
                <td className="px-4 py-3 text-xs font-mono" style={{ color: "var(--color-muted-foreground)" }}>{item?.version}</td>
                <td className="px-4 py-3 text-xs whitespace-nowrap" style={{ color: "var(--color-muted-foreground)" }}>{item?.downloadedAt}</td>
                <td className="px-4 py-3">
                  <span className="text-xs px-2 py-1 rounded-full bg-emerald-100 text-emerald-700 font-medium">
                    {item?.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* Mobile cards */}
      <div className="md:hidden divide-y" style={{ borderColor: "var(--color-border)" }}>
        {paginated?.map((item) => (
          <div key={item?.id} className="p-4 flex items-center gap-3">
            <div className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0" style={{ backgroundColor: "var(--color-muted)" }}>
              <Icon name="Download" size={14} color="var(--color-primary)" />
            </div>
            <div className="min-w-0 flex-1">
              <p className="text-sm font-medium truncate" style={{ color: "var(--color-foreground)" }}>{item?.name}</p>
              <p className="text-xs" style={{ color: "var(--color-muted-foreground)" }}>v{item?.version} · {item?.downloadedAt}</p>
            </div>
            <span className="text-xs px-2 py-1 rounded-full bg-emerald-100 text-emerald-700 font-medium flex-shrink-0">
              {item?.status}
            </span>
          </div>
        ))}
      </div>
      {totalPages > 1 && (
        <div className="p-4 border-t flex items-center justify-between" style={{ borderColor: "var(--color-border)" }}>
          <p className="text-xs" style={{ color: "var(--color-muted-foreground)" }}>
            Página {page} de {totalPages}
          </p>
          <div className="flex gap-2">
            <button
              disabled={page === 1}
              onClick={() => setPage(page - 1)}
              className="w-8 h-8 rounded-lg border flex items-center justify-center disabled:opacity-40 transition-colors hover:bg-gray-50"
              style={{ borderColor: "var(--color-border)" }}
            >
              <Icon name="ChevronLeft" size={14} color="var(--color-foreground)" />
            </button>
            <button
              disabled={page === totalPages}
              onClick={() => setPage(page + 1)}
              className="w-8 h-8 rounded-lg border flex items-center justify-center disabled:opacity-40 transition-colors hover:bg-gray-50"
              style={{ borderColor: "var(--color-border)" }}
            >
              <Icon name="ChevronRight" size={14} color="var(--color-foreground)" />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default DownloadHistory;